import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Box } from '../Box/index.js';

/**
 * Flex is Box with `display: flex` and comes with helpful shorthand styles.
 * It renders a div element.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/flex#usage)
 * - [Props](https://blockparty.endpoint.com/components/flex#props)
 * <br />
 *
 */
const Flex = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    align,
    justify,
    direction,
    ...props
  } = _ref;
  const styles = {
    alignItems: align,
    justifyContent: justify,
    flexDirection: direction
  };
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: ref,
    display: "flex"
  }, styles, props), children);
});

export { Flex };
